import type { ContenidoAyuda, ItemAyuda } from "@/ui/AyudaVista";
import {
  BOTONES_CORREOS_IA,
  FICHAS_CORREOS_IA,
  botonesApuntesYEvidencias,
} from "./redaccionComun";

/**
 * Ayuda de «Abrir ticket en Queclink» / «Ligar ticket de Queclink»
 * (`components/CrearTicketQueclinkModal`). Cada modo enseña sus botones.
 */
export function ayudaTicketQueclink({
  modo,
  iaHabilitada,
}: {
  modo: "crear" | "manual";
  iaHabilitada: boolean;
}): ContenidoAyuda {
  const botones: ItemAyuda[] = [
    {
      label: "Crear nuevo / Ya tengo el número",
      text: "Cambia entre abrir un ticket nuevo en Queclink y ligar al caso uno que ya existe.",
    },
  ];

  if (modo === "manual") {
    botones.push(
      {
        label: "Ligar ticket",
        text: "Comprueba en Queclink que ese número exista y lo liga al caso; en la siguiente revisión su hilo entra a la bitácora. Sale gris sin número.",
      },
      { label: "Cancelar", text: "Cierra sin ligar nada." },
    );
    return {
      manual: "jimi",
      intro: (
        <p>
          Liga al caso un ticket que ya existe en Queclink. Sirve para los que se abrieron a mano
          o desde el correo: como su asunto no trae el TE del caso, no se ligan solos.
        </p>
      ),
      secciones: [
        { titulo: "Qué hace cada botón", items: botones },
        {
          titulo: "Atajos de teclado",
          items: [{ label: "Enter", text: "En el número, lo liga (igual que «Ligar ticket»)." }],
        },
      ],
    };
  }

  if (iaHabilitada) {
    botones.push({
      label: "✨ Redactar con IA",
      text: "Redacta la descripción para el proveedor con las notas de la bitácora, los contactos, los equipos y los correos que marques; lo que ya está escrito sirve de guía. Reemplaza la descripción sin preguntar: revísala antes de abrir el ticket. Necesita al menos una nota escrita a mano en la bitácora.",
    });
  }
  botones.push(...botonesApuntesYEvidencias("la descripción"));
  if (iaHabilitada) botones.push(...BOTONES_CORREOS_IA);
  botones.push(
    {
      label: "Abrir ticket",
      text: "Todavía no crea nada: te pide confirmar. Sale gris mientras carga o si falta el asunto o la descripción.",
    },
    {
      label: "Sí, abrir el ticket",
      text: "Ahora sí lo crea en Queclink, tal cual, y lo liga al caso. Si cambias algo, vuelve a pedir confirmación.",
    },
    { label: "Cancelar", text: "Cierra sin abrir nada. Lo que escribiste se pierde." },
  );

  return {
    manual: "jimi",
    intro: (
      <p>
        Abre un ticket en el portal de soporte de Queclink desde el caso y lo deja ligado a él. Se
        crea en su sistema y no se puede borrar después; por eso pide confirmación. El asunto y
        la descripción vienen propuestos: edítalos antes.
      </p>
    ),
    secciones: [
      { titulo: "Qué hace cada botón", items: botones },
      { titulo: "Qué significa cada indicador", items: iaHabilitada ? FICHAS_CORREOS_IA : [] },
    ],
  };
}
